// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarExamen_main__eWN5A","intro":"ModalEditarExamen_intro__6Hf0K","input":"ModalEditarExamen_input__EOdHO"};